import { houseAddressKeys } from './HouseAddress';

export const getTempElementId = (elementId: string, type: houseAddressKeys) => {
    return elementId + '-' + type;
};
